import partnerIndex from '../../pages/partner'

const PartnerRoute = [
  {
    path: '/partner',
    name: 'partner',
    component: partnerIndex
  }
]
export default PartnerRoute



// WEBPACK FOOTER //
// ./src/router/partner/index.js